module.exports = __webpack_public_path__ + "img/img_32418_0_10.71b681da.png";